import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { CategoryCircle } from "@/pages/Home";
import { SectionHeading } from "@/components/company/CompanySections";

const MAX = 8;

/* Store Preview — kategori dari /categories existing (maks 8) + produk homepage dari
   GET /public/company-profile/products (MANUAL/FEATURED/BEST_SELLER + fallback dihitung server, ProductCard existing).
   Tidak ada salinan data produk/kategori di company_profile. */
export function StorePreviewSection({ data, catalogPath = "/katalog" }) {
  const [cats, setCats] = useState([]);
  const [products, setProducts] = useState([]);
  const [source, setSource] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!data) return undefined;
    let alive = true;
    Promise.allSettled([api.get("/categories"), api.get("/public/company-profile/products")]).then(([c, p]) => {
      if (!alive) return;
      if (c.status === "fulfilled") setCats((c.value.data || []).slice(0, MAX));
      if (p.status === "fulfilled") { setProducts((p.value.data?.items || []).slice(0, MAX)); setSource(p.value.data?.source || null); }
      setLoading(false);
    });
    return () => { alive = false; };
  }, [data]);

  if (!data || (!loading && cats.length === 0 && products.length === 0)) return null;
  return (
    <section id="toko" className="storefront-section cp-anchor" data-testid="company-store-preview" data-source={source || undefined} aria-labelledby="cp-store-title">
      <div className="storefront-section-heading flex items-end justify-between gap-4">
        <SectionHeading eyebrow="Toko" title={data.title || "Produk Kami"} id="cp-store-title" />
        <Link to={catalogPath} className="storefront-view-all brand-text-primary" data-testid="company-store-view-all">Lihat semua <ArrowRight size={16} /></Link>
      </div>
      {cats.length > 0 ? (
        <div className="storefront-category-rail flex gap-3 sm:gap-4 overflow-x-auto no-scrollbar pb-2" data-testid="company-store-categories">
          {cats.map((c) => <CategoryCircle key={c.id || c.slug} slug={c.slug} name={c.name} icon={c.icon} imageUrl={c.image_url} />)}
        </div>
      ) : null}
      {products.length > 0 ? (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-5 mt-6" data-testid="company-store-products">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      ) : null}
      <div className="mt-8 flex justify-center">
        <Link to={catalogPath} className="cp-btn cp-btn--primary" data-testid="company-store-cta">{data.cta_label || "Lihat Semua Produk"} <ArrowRight size={16} aria-hidden="true" /></Link>
      </div>
    </section>
  );
}
